export default __webpack_public_path__ + "static/media/homepoint-logo-blue.b2bc1d6a.svg";